import React from 'react';

import { Flights } from '@shared/v2/services/types/api/parsedResponse';
import { isReturnFlightOptions } from '@shared/v2/utils/types/flightOptions';

import useDestination from '@/hooks/useDestination';
import useSearchQuery from '@/hooks/useSearchQuery';
import checkout from '@/utils/checkout';
import { UI } from '@/v2/types';
import { useRoomOptionsData } from '../../contexts/RoomOptionsContext';
import { useFlightOptions } from '../../hooks/useFlightOptions';
import {
  ReturnFlightOptions,
  StandardFlightOptions,
} from './components/FlightOptions';

interface FlightOptionsViewProps {
  propertyContent: UI.Property;
  procuredOffer: UI.ProcuredOffer | null;
}

const FlightOptionsView = ({
  propertyContent,
  procuredOffer,
}: FlightOptionsViewProps) => {
  const { searchQuery } = useSearchQuery() || {};
  const destination = useDestination();
  const { selectedRoomOption } = useRoomOptionsData() || {};

  const { flightOptions } = useFlightOptions();

  const offerId =
    searchQuery?.offerId ?? selectedRoomOption?.matchingOffer?.hotelOffer?.id;

  if (!offerId) return null;

  const offer = selectedRoomOption?.offers?.filter(
    (offer) => offerId === offer.hotelOffer.id,
  )?.[0];

  const onConfirmFlights = ({ segments }: { segments: Flights }) => {
    checkout({
      destination,
      propertyContent,
      roomType: selectedRoomOption?.roomType,
      packageOffer: selectedRoomOption?.matchingOffer,
      flightSegments: segments,
      searchQuery,
      isProcuredOffer: !!procuredOffer,
    });
  };

  if (isReturnFlightOptions(flightOptions)) {
    return (
      <ReturnFlightOptions
        flightOptions={flightOptions.returnJourneys}
        charges={offer?.charges}
        onConfirmFlights={onConfirmFlights}
        offerId={offer?.hotelOffer.id}
      />
    );
  }

  return (
    <StandardFlightOptions
      loading={false}
      flightOptions={flightOptions}
      charges={offer?.charges}
      onConfirmFlights={onConfirmFlights}
      offerId={offer?.hotelOffer.id}
    />
  );
};

export default FlightOptionsView;
